import React from "react";

export class ResponsibleDisclosureDE extends React.Component {
    render() {
        return (
            <>
                <p>
                    Letztes Update: <b>29/03/2024</b>
                    <br />
                    <br />
                </p>

                <p>DH Healthcare GmbH legt großen Wert auf die Sicherheit seiner Informationen und Systeme.</p>

                <p>Trotz unserer Sorge um die Sicherheit dieser Systeme kann es vorkommen, dass immer noch eine Schwachstelle vorhanden ist.</p>

                <p>
                    Sollten Sie eine Schwachstelle in einem unserer Systeme gefunden haben, teilen Sie uns dies bitte mit, damit wir schnellstmöglich Maßnahmen einleiten können.
                    Wir möchten mit Ihnen zusammenarbeiten, um unsere Daten, unsere Nutzer und unsere Systeme besser zu schützen.
                </p>

                <p>
                    Wir haben uns daher für eine Richtlinie zur koordinierten Offenlegung von Schwachstellen (auch bekannt als „Richtlinie zur verantwortungsvollen Offenlegung“)
                    entschieden, damit Sie uns informieren können, wenn Sie eine Schwachstelle entdecken.
                </p>

                <p>Diese Richtlinie zur verantwortungsvollen Offenlegung gilt für die folgenden Systeme, die von DH Healthcare GmbH verwaltet werden:</p>
                <ul>
                    <li>
                        <a href="https://www.dedalus.com/be/en/our-offer/products/pacsonweb/" target="_blank" rel="noreferrer">
                            www.dedalus.com
                        </a>
                    </li>
                    <li>
                        <a href="https://secure.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://secure.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://france.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://france.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://norway.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://norway.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://swiss.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://swiss.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://germany.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://germany.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://latem.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://latem.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://brazil.imaging.dedalus.com" target="_blank" rel="noreferrer">
                            https://brazil.imaging.dedalus.com
                        </a>
                    </li>
                    <li>
                        <a href="https://austria.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://austria.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://swisscom.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://swisscom.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://labs.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://labs.pacsonweb.com
                        </a>
                    </li>

                    <li>
                        <a href="https://secure.risonweb.com" target="_blank" rel="noreferrer">
                            https://secure.risonweb.com
                        </a>
                    </li>
                </ul>

                <p>
                    Bitte kontaktieren Sie uns im Zweifelsfall zur Klärung über <a href="mailto:security.disclosure@dedalus.com">security.disclosure@dedalus.com</a>
                </p>

                <h2>Was wir von dir verlangen</h2>

                <p>Wenn Sie eine Schwachstelle in einem unserer Systeme entdecken, bitten wir Sie:</p>

                <ul>
                    <li>
                        Melden Sie die Schwachstelle so schnell wie möglich nach der Entdeckung. Mailen Sie Ihre Ergebnisse an{" "}
                        <a href="mailto:security.disclosure@dedalus.com">security.disclosure@dedalus.com</a>.
                    </li>
                    <li>
                        Geben Sie ausreichende Informationen an, um die Schwachstelle zu reproduzieren, damit wir das Problem so schnell wie möglich beheben können. Normalerweise
                        ist die URL des betroffenen Systems und eine Beschreibung der Schwachstelle ausreichend, bei komplexeren Schwachstellen können jedoch weitere erforderlich
                        sein.
                    </li>
                    <li>
                        Hinterlassen Sie Ihre Kontaktdaten, damit DH Healthcare GmbH Sie kontaktieren kann, um gemeinsam an einem sicheren Ergebnis zu arbeiten. Hinterlassen Sie
                        mindestens Ihren Namen, Ihre E-Mail-Adresse und/oder Ihre Telefonnummer. Die Meldung unter einem Pseudonym ist möglich, aber stellen Sie sicher, dass wir
                        Sie bei weiteren Fragen kontaktieren können.
                    </li>
                    <li>Bestätigen Sie, dass Sie gemäß dieser Richtlinie zur verantwortungsvollen Offenlegung gehandelt haben und weiterhin handeln werden.</li>
                </ul>

                <h2>Regeln, die Sie befolgen müssen</h2>

                <ul>
                    <li>Geben Sie die Schwachstelle nicht bekannt, bis wir sie beheben konnten. Siehe unten für mögliche Veröffentlichung</li>
                    <li>
                        Nutzen Sie die Sicherheitslücke nicht durch unnötiges Kopieren, Löschen, Anpassen oder Anzeigen von Daten. Oder beispielsweise indem mehr Daten
                        heruntergeladen werden, als zum Nachweis der Schwachstelle erforderlich sind.
                    </li>
                    <li>
                        Wenden Sie die folgenden Aktionen nicht an:
                        <ul>
                            <li>Platzieren von Malware (Virus, Wurm, Trojanisches Pferd usw.).</li>
                            <li>Kopieren, Ändern oder Löschen von Daten in einem System.</li>
                            <li>Änderungen am System vornehmen.</li>
                            <li>Wiederholtes Zugreifen auf das System oder Teilen des Zugangs mit anderen.</li>
                            <li>Verwendung automatischer Scan-Tools.</li>
                            <li>Nutzung der sogenannten "brute force" des Zugriffs auf Systeme.</li>
                            <li>Verwendung von (D)DOS-Angriffen, physischen Angriffen oder Social Engineering (Phishing, Vishing, Spam,...).</li>
                        </ul>
                    </li>
                    <li>Löschen Sie unverzüglich alle Daten, die durch Sicherheitslücken erlangt wurden, sobald diese an DH Healthcare GmbH gemeldet wurden.</li>
                    <li>
                        Führen Sie keine Aktionen durch, die die ordnungsgemäße Funktion des Systems beeinträchtigen könnten, sowohl in Bezug auf Verfügbarkeit und Leistung, als
                        auch in Bezug auf Vertraulichkeit und Integrität der Daten.
                    </li>
                </ul>

                <p>
                    Handlungen gemäß dieser Richtlinie zur verantwortungsvollen Offenlegung sollten sich auf die Durchführung von Tests zur Identifizierung potenzieller
                    Schwachstellen und die Weitergabe dieser Informationen an DH Healthcare GmbH beschränken.
                </p>
                <p>
                    Wenn Sie nach Beseitigung der Schwachstelle Informationen zur Schwachstelle veröffentlichen möchten, bitten wir Sie, uns dies mindestens einen Monat vor der
                    Veröffentlichung mitzuteilen und uns Gelegenheit zur Stellungnahme zu geben. Eine Nennung uns in einer Veröffentlichung ist nur nach unserer ausdrücklichen
                    Zustimmung möglich.
                </p>

                <h2>Unsere Verpflichtungen</h2>

                <p>Wenn Sie die obigen Bestimmungen der Richtlinie zur verantwortungsvollen Offenlegung eingehalten haben und keine anderen Verstöße begangen haben,</p>
                <ul>
                    <li>Wir werden keine rechtlichen Schritte gegen Sie einleiten.</li>
                    <li>
                        Wir werden innerhalb kurzer Zeit, möglichst innerhalb von 10 Arbeitstagen, auf Ihren Bericht mit unserer Prüfung des Berichts und einem voraussichtlichen
                        Datum für die Lösung antworten.
                    </li>
                    <li>
                        Wir behandeln Ihre Meldung vertraulich und geben Ihre personenbezogenen Daten nicht ohne Ihre Einwilligung an Dritte weiter, es sei denn, dies ist zur
                        Erfüllung einer gesetzlichen Verpflichtung erforderlich.
                    </li>
                    <li>Wir halten Sie über den Fortschritt der Problemlösung auf dem Laufenden.</li>
                    <li>
                        Wir möchten Ihnen für die Meldung eines uns noch nicht bekannten Sicherheitsproblems danken, indem wir Ihnen die Möglichkeit bieten, in unsere "Hall Of
                        Fame" aufgenommen zu werden.
                    </li>
                    <li>Wir bemühen uns, alle Probleme innerhalb kurzer Zeit zu lösen.</li>
                </ul>

                <p>Wir können uns jedoch dafür entscheiden, Berichte von geringer Qualität zu ignorieren.</p>
                <p>
                    Bei Fragen wenden Sie sich bitte an <a href="mailto:security.disclosure@dedalus.com">security.disclosure@dedalus.com</a>
                </p>
                <p>
                    Bei Zweifeln über die Anwendbarkeit dieser Richtlinie kontaktieren Sie uns bitte zuerst über diese E-Mail-Adresse, um eine ausdrückliche Genehmigung einzuholen.
                </p>
                <p>Wir behalten uns das Recht vor, den Inhalt dieser Richtlinie jederzeit zu ändern oder die Richtlinie zu kündigen.</p>
                <p>Dieser Text ist ein abgeleitetes Werk von "Responsible Disclosure" von Floor Terra, das unter einer Creative Commons Attribution License 3.0 verwendet wird.</p>
            </>
        );
    }
}
